import { useEffect, useMemo, useState } from "react";

// Paginação client-side pra lista que já veio inteira do backend (dashboards
// de comparação: o filtro é feito em memória, não tem endpoint paginado).
// Devolve o mesmo formato de `meta` que o componente <Pagination> já espera
// (total/page/last_page/isLastPage), pra reusar o mesmo componente das telas
// com paginação de servidor.
export function usePagedList(items, pageSize = 10) {
  const [page, setPage] = useState(1);
  const list = items || [];

  // Reseta pra página 1 sempre que a lista muda (filtro de ano, troca de aba
  // de série, etc.) — senão a página pode apontar pra além do novo total e a
  // seção "some" sem aviso (mesma armadilha de EG-39).
  useEffect(() => {
    setPage(1);
  }, [list]);

  const lastPage = Math.max(Math.ceil(list.length / pageSize), 1);
  const safePage = Math.min(page, lastPage);

  const pageItems = useMemo(
    () => list.slice((safePage - 1) * pageSize, safePage * pageSize),
    [list, safePage, pageSize]
  );

  return {
    page: safePage,
    setPage,
    pageItems,
    meta: {
      total: list.length,
      page: safePage,
      last_page: lastPage,
      isLastPage: safePage >= lastPage,
    },
  };
}
